export default __webpack_public_path__ + "static/media/cake28.2cb0d22d.jpeg";